<template>
  <div>
    <section v-if="data" class="mbr-section mbr-section-md-padding mbr-footer footer2" id="contacts2-a"
             data-rv-view="38"
             style="background-color: rgb(46, 46, 46); padding-top: 90px; padding-bottom: 90px;">

      <div class="container">
        <div class="row">
          <div class="mbr-footer-content col-xs-12 col-md-3">
            <p><strong>{{ data.address.name }}</strong><br>Rod. GO-010, Km 125, Zona Rural, <br>Silvânia-Goiás - CEP
              75180-000<br><br>E-mail: brmill@brmillalimentos.com.br<br>Telefone: 55 (62)
              3332-9182&nbsp;<br><br>
              <strong>{{ data.contacts.name }}</strong><br>{{ data.contacts.dc }}<br>E-mails:<br>comercial@brmillalimentos.com.br<br>comercial2@brmillalimentos.com.br<br>{{ data.contacts.phones }}:<br>(62)
              9 91661548<br>(62) 9 93456153<br>_____________________________<br>{{ data.contacts.de }}<br>+55 62 9
              9305-4938<br>+55 62 3636-8307<br>export@brmillalimentos.com.br&nbsp;<br></p>
          </div>
          <div class="mbr-footer-content col-xs-12 col-md-3"><p class="mbr-contacts__text"><font
              color="#7c7c7c" face="Montserrat, sans-serif"><span
              style="font-size: 16px; letter-spacing: -1px;"><strong>{{ data.segment.name }}</strong></span></font>
          </p>
            <ul>
              <li>{{ data.segment.ia }}</li>
              <li>{{ data.segment.na }}</li>
            </ul>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="mbr-map">
              <iframe frameborder="0" style="border:0"
                      src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAEIpgj38KyLFELm2bK9Y7krBkz1K-cMq8&amp;q=place_id:Eh5HTy0wMTAsIFNpbHbDom5pYSAtIEdPLCBCcmF6aWwiLiosChQKEgl9ktBtX_FekxG39lzZNq3MIhIUChIJQ-3XwtQuWZMRP_rSZqBf-aw"
                      allowfullscreen=""></iframe>
            </div>
          </div>




        </div>
      </div>
    </section>

    <section class="mbr-section mbr-section-md-padding" id="social-buttons4-e" data-rv-view="40"
             style="background-color: rgb(46, 46, 46); padding-top: 0px; padding-bottom: 0px;">

      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-xs-center">
            <div>
              <a class="btn btn-social" title="Facebook" target="_blank"
                 href="https://www.facebook.com/BRMill-Alimentos-366279990152199/">
                <i class="socicon socicon-facebook"></i></a>
              <a class="btn btn-social text-center" title="Instagram"
                 target="_blank"
                 href="https://www.instagram.com/brmillalimentos">
                <i class="socicon socicon-instagram"></i></a>
              <a class="btn btn-social" title="LinkedIn"
                 target="_blank"
                 href="https://www.linkedin.com/company/brmill-alimentos/">
                <i class="socicon socicon-linkedin"></i></a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <input name="animation" type="hidden"></div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      language: {},
      data: '',
      pt: {
        address: {
          name: 'Endereço',
        },
        contacts: {
          name: 'Contatos',
          dc: 'Departamento Comercial',
          de: 'Departamento de Exportação',
          phones: 'Telefones'
        },
        segment: {
          name: 'SEGMENTO DE MERCADO DE NOSSOS PRODUTOS:',
          ia: 'Indústria Alimentícia',
          na: 'Nutrição Animal',
        },
        certificate: 'Certificações'
      },
      en: {
        address: {
          name: 'Address',
        },
        contacts: {
          name: 'Contacts',
          dc: 'Commercial Department',
          de: 'Export Department',
          phones: 'Phones'
        },
        segment: {
          name: 'MARKET SEGMENT OF OUR PRODUCTS:',
          ia: 'Food Industry',
          na: 'Animal Nutrition',
          oi: 'Other Industries',
        },
        certificate: 'Certifications'
      },
      es: {
        address: {
          name: 'Dirección',
        },
        contacts: {
          name: 'Contactos',
          dc: 'Departamento Comercial',
          de: 'Departamento de exportación',
          phones: 'Los telefonos\n'
        },
        segment: {
          name: 'SEGMENTO DE MERCADO DE NUESTROS PRODUCTOS:',
          ia: 'Industria Alimentar',
          na: 'Nutrición Animal',
          oi: 'Otras industrias',
        },
        certificate: 'Certificaciones'
      },
    }
  },
  components: {},
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }
    if (this.language == 'pt') {
      this.data = this.pt;
    }
    if (this.language == 'en') {
      this.data = this.en;
    }
    if (this.language == 'es') {
      this.data = this.es;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
